module.exports = __webpack_public_path__ + "static/media/healthcommission.265a7a59.png";